module.exports = __webpack_public_path__ + "8711d2ce810e5ca2b4895417918a852a.pdf";